// shared components
import { parseUserRole } from '@/components/access-control/userRole';

// relative
import { useAccountPermissions } from './useAccountPermissions';

/**
 * Returns the current user's account role and superuser status in terms
 * of the UserRole enum, ready to be consumed by AccessGuard.
 */
export function useCurrentUserAccess() {
  const { accountRole, isSuperUser } = useAccountPermissions();

  return {
    role: parseUserRole(accountRole),
    isSuperuser: isSuperUser,
  };
}
